import { html } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { ChameleonElementMixin } from '../../common/mixin';
export const dataTableCellTemplate = html `<template role="cell"><slot></slot></template>`;
export class DataTableCellComponent extends ChameleonElementMixin(FoundationElement) {
}
